import React from 'react';
import glamorous, { withTheme } from 'glamorous';
import { lighten } from 'polished';

const ErrorList = ({
  request: { detailedErrors: requestErrorList = [], message: requestErrMsg } = {
  },
  theme: { colors = {} },
}) => {
  return (
    <glamorous.Div color={lighten(0.2, colors.error || 'red')} margin="10px 0px">
      <glamorous.H3 fontSize="1.4rem">
        {requestErrMsg}
      </glamorous.H3>
      {requestErrorList.map(({ message }, i) => <p key={i}>{message}</p>)}
    </glamorous.Div>
  );
};

export default withTheme(ErrorList);



// WEBPACK FOOTER //
// ./src/App/events/components/ErrorList.js